export default __webpack_public_path__ + "static/media/i_bus-jeonse_bl_tagless.41fcab2e.svg";